import { Component, computed, inject } from "@angular/core"
import { NgOptimizedImage } from "@angular/common"
import { StorageService } from "../../../../services/storage.service"

@Component({
  imports: [
    NgOptimizedImage,
  ],
  providers: [],
  standalone: true,
  template: `
    <div class="border-l-8 border-dashed border-primary-content">
      <div class="row gap-0 items-stretch">
        <div 
          style="flex: 4"
          class="min-w-80 mr-10 column text-primary-content font-black leading-5 text-2xl" 
        >
          <div class="border-b-8 border-dashed border-primary-content p-10">
            <div>
              REDLINING DESIGNED
            </div>
            <div>
              STRUCTURAL RACISM INTO OUR NEIGHBORHOODS...
            </div>
          </div>
          <div class="border-r-8 border-dashed border-primary-content p-10 flex-1">
            <div class="center">
              IT HAS NEVER BEEN UNDESIGNED.
            </div>
            <div class="pt-24 pr-14">
              REDLINING EMBODIES A PROCESS THAT TRANSFORMED EXPLICIT RACISM INTO STRUCTURAL RACISM.
              THESE STRUCTURAL CONDITIONS LARGELY REMAIN TODAY.
            </div>
          </div>
        </div>
        <div
          style="flex: 2; aspect-ratio: 16/9"
          class="min-w-40 ml-auto relative" 
        >
          <img
            [ngSrc]="mapImageSrc()" 
            alt="Banner Map"
            class="object-contain object-right"
            priority
            fill 
          />
        </div>
      </div>
    </div>
  `,
  selector: "e2e-banner",
})
export class BannerComponent {
  private storageService = inject(StorageService)

  mapImageSrc = computed(() =>
    this.storageService.getFileUrl("assets/pages/intro/map-image.png")
  )

}
